import React from 'react';

const Download = (props) => {
    const { size } = props
    return (
        <svg xmlns='http://www.w3.org/2000/svg' id='Capa_1' width={13 || size} height={13 || size}
            viewBox='0 0 438.533 438.533'>
            <g fill='#787878'>
                <path d='M382.58,108.493l-89.078-89.081c-9.521-9.517-22.087-15.706-37.692-18.558v145.324h145.326 C398.281,130.566,392.091,118.006,382.58,108.493z'
                />
                <path d='M246.676,182.72c-7.617,0-14.089-2.663-19.417-7.993c-5.33-5.327-7.992-11.799-7.992-19.414V0H63.953 C56.341,0,49.869,2.663,44.54,7.993c-5.33,5.327-7.994,11.799-7.994,19.414v383.719c0,7.617,2.664,14.089,7.994,19.417 c5.33,5.325,11.801,7.991,19.414,7.991h310.633c7.611,0,14.079-2.666,19.407-7.991c5.328-5.332,7.994-11.8,7.994-19.417V182.72 H246.676z'
                />
            </g>
        </svg>
    )
}
export default Download;


// WEBPACK FOOTER //
// ./src/icon/DownloadIcon.js